import {
    Box,
    Button,
    Container,
    ImageList,
    ImageListItem,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import React from 'react';
import Background from '../../assets/Images/heroBackground.webp';
import DotIcon from '../../assets/icons/DotIcon';
import CodeIcon from '../../assets/icons/CodeIcon';
import TriangleIcon from '../../assets/icons/TriangleIcon';
import FallingStar from '../../assets/icons/FallingStar';
import ChartUpIcon from '../../assets/icons/ChartUpIcon';
import BackgroundCheckIcon from '../../assets/icons/BackgroundCheckIcon';
import FilterIcon from '../../assets/icons/FilterIcon';
import WeightsIcon from '../../assets/icons/WeightsIcon';
import UserProfileCard from '../../assets/icons/UserProfileCard';
import { Link } from 'react-router-dom';
import LandingBriefCase from '../../assets/icons/LandingBriefCase';
import suitcase from '../../assets/Images/Suitcase.webp';
// import BackgroundCareer from '../../assets/Images/'

const GettingAJob = () => {
    const theme = useTheme();
    const medium = useMediaQuery(theme.breakpoints.down('md'));
    const mobile = useMediaQuery(theme.breakpoints.down('lg'));

    const listItems = [
        {
            icon: <CodeIcon />,
            text: 'Get pre-vetted candidates for your jobs in minutes and fill your open positions in days not months'
        },
        {
            icon: <TriangleIcon />,
            text: 'We vet them, you get them. Your requirements, our prequalified top talents'
        },
        {
            icon: <FallingStar />,
            text: 'Get pre-qualified and find your next job in a matter of days'
        },
        {
            icon: <ChartUpIcon />,
            text: 'Scored up-front for your convenience and peace of mind.'
        },
        { icon: <BackgroundCheckIcon />, text: 'Background checks' },
        { icon: <FilterIcon />, text: 'Reference Check' },
        { icon: <WeightsIcon />, text: 'Skills Assessments' },
        { icon: <LandingBriefCase />, text: 'Work Achievements verification' },
        { icon: <UserProfileCard />, text: 'Behavioral Assessments' }
    ];

    return (
        <Stack
            position="relative"
            pt={mobile ? '60px' : '80px'}
            pb={mobile ? '60px' : '80px'}
            sx={{
                // bgcolor: '#FCFBF8',
                background:
                    mobile || medium
                        ? 'linear-gradient(114.64deg, #FFF9ED 1.2%, #D5F3FE 97.96%)'
                        : 'linear-gradient(111.74deg, #FDE6FA -0.73%, #D6F0FF 105.17%)',
                backgroundBlendMode: 'overlay'
                // background: linear-gradient(114.64deg, #FFF9ED 1.2%, #D5F3FE 97.96%);
            }}
        >
            <Stack
                position="absolute"
                top={0}
                bottom={0}
                left={0}
                right={0}
                sx={{
                    backgroundImage: `url(${Background})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}
            ></Stack>
            <Container
                maxWidth="xl"
                disableGutters
                sx={{
                    // px: '16px',
                    position: 'relative'
                }}
            >
                <Stack
                    maxWidth={'100%'}
                    marginRight={{ xs: 0, lg: '60px' }}
                    marginLeft={{ xs: 0, lg: '-5%' }}
                    position={'relative'}
                >
                    <Stack
                        flexDirection={{
                            xs: 'column-reverse',
                            lg: 'row-reverse'
                        }}
                        alignItems="center"
                        justifyContent={'flex-end'}
                        gap="40px"
                    >
                        <Stack
                            flex={1}
                            sx={{
                                display: 'flex',
                                maxWidth: medium ? '100%' : '630px',
                                flexDirection: medium ? 'column' : 'column',
                                alignItems: mobile ? 'center' : 'flex-start',
                                justifyContent: 'center',
                                gap: '18px',
                                px: { xs: '16px', sm: 0 }
                                // mb: '16px'
                            }}
                        >
                            <Typography
                                sx={{
                                    color: '#464646',
                                    fontFamily: 'CabinetGrotesk-Variable',
                                    fontSize: { xs: '20px', sm: '36px' },
                                    fontStyle: 'normal',
                                    lineHeight: '43px',
                                    alignSelf: {
                                        xs: 'flex-start',
                                        sm: 'center'
                                    },
                                    // letterSpacing: '-3px',
                                    maxWidth: '630px',
                                    fontWeight: 800
                                    // whiteSpace: 'break-spaces'
                                    // overflowWrap: 'break-word'
                                }}
                            >
                                Getting a Job and Hiring Made Easy
                            </Typography>
                            <Typography
                                maxWidth="630px"
                                color="#23282B"
                                fontSize={'20px'}
                                fontWeight="500"
                                lineHeight="30px"
                                fontFamily="Outfit"
                                fontStyle="normal"
                                letterSpacing="0.92px"
                            >
                                <List>
                                    {listItems.map((item) => (
                                        <ListItem
                                            sx={{
                                                alignItems: 'flex-start',
                                                gap: '16px',
                                                px: 0
                                            }}
                                        >
                                            <Box>{item.icon}</Box>
                                            <ListItemText
                                                sx={{
                                                    fontSize: {
                                                        xs: '14px',
                                                        sm: '16px'
                                                    }
                                                }}
                                                primary={item.text}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    // margin: '6px',
                                    alignItems: 'center',
                                    gap: '20px',
                                    width: '100%',
                                    justifyContent: {
                                        xs: 'center',
                                        lg: 'space-between'
                                    }
                                }}
                            >
                                <Link
                                    to="/create-account"
                                    rel="noopener"
                                    style={{ width: '100%' }}
                                >
                                    <Button
                                        sx={{
                                            // gap: '30px',
                                            height: { xs: '44px', sm: '64px' },
                                            padding: { xs: 0, lg: '16px 52px' },
                                            borderRadius: '100px',
                                            fontWeight: 600,
                                            lineHeight: '24px',
                                            letterSpacing: '0.024px',
                                            fontFamily: 'Outfit',
                                            fontSize: '16px',
                                            marginRight: '12px',
                                            width: { xs: '100%', lg: '300px' }
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Find a job
                                    </Button>
                                </Link>
                                <Link
                                    to="/login"
                                    rel="noopener"
                                    style={{ width: '100%' }}
                                >
                                    <Button
                                        sx={{
                                            // gap: '12px',
                                            bgcolor: '#fff',
                                            height: { xs: '44px', sm: '64px' },
                                            padding: { xs: 0, lg: '16px 52px' },
                                            borderRadius: '100px',
                                            fontWeight: 600,
                                            lineHeight: '24px',
                                            letterSpacing: '0.024px',
                                            fontFamily: 'Outfit',
                                            fontSize: '16px',
                                            width: { xs: '100%', lg: '300px' }
                                        }}
                                        variant="outlined"
                                        color="primary"
                                    >
                                        Hire talent
                                    </Button>
                                </Link>
                            </Box>
                        </Stack>
                        <Stack
                            width={'100%'}
                            maxWidth={{ xs: '100%', sm: '80%' }}
                            alignSelf={{ lg: 'flex-start', sm: 'center' }}
                            data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-delay={medium ? '500' : '1300'}
                            sx={{
                                flexDirection: 'column',
                                margin: 0
                            }}
                        >
                            <ImageList cols={1} sx={{ m: 0 }}>
                                <ImageListItem>
                                    <img
                                        src={suitcase}
                                        alt="Man walking with a leather suitcase as the focal point"
                                    />
                                </ImageListItem>
                            </ImageList>
                        </Stack>
                    </Stack>
                </Stack>
            </Container>
        </Stack>
    );
};

export default GettingAJob;
